import { alpha } from '@mui/material/styles'
import theme from '../base'

const button = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiButton: {
    defaultProps: {
      color: 'primary',
      variant: 'contained',
      disableFocusRipple: true,
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        padding: theme.spacing(2, 4),
        borderRadius: 0,
        ...theme.typography.inputText,
        textTransform: 'initial',

        '&.mini': {
          padding: theme.spacing(0.5, 1),
          fontSize: 12,
        },
      },
      contained: {
        boxShadow: 'none',

        '&:hover, &:active, &:focus-visible': {
          boxShadow: theme.shadows[1],
        },

        '&.Mui-disabled': {
          backgroundColor: theme.palette.neutral.light,
          color: theme.palette.neutral.lighter,
        },
      },
      containedPrimary: {
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
        },

        '&:active, &:focus-visible': {
          backgroundColor: theme.palette.primary.dark,
        },
      },
      outlined: {
        padding: theme.spacing(2, 4),
        outline: '1px solid',
        outlineOffset: -1,
        border: 'none',
        transition: theme.transitions.create('outline', {
          duration: theme.transitions.duration.short,
        }),

        '&.Mui-disabled': {
          backgroundColor: theme.palette.neutral.white,
          outlineColor: theme.palette.neutral.lighter,
          color: theme.palette.neutral.lighter,
        },
      },
      outlinedPrimary: {
        border: 'none',
        outlineColor: theme.palette.primary.lightest,

        '&:hover': {
          border: 'none',
          backgroundColor: theme.palette.neutral.white,
          outlineColor: theme.palette.primary.main,
        },

        '&:active, &:focus-visible': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.neutral.white,
          outlineColor: theme.palette.primary.main,
        },

        '&:hover, &:active, &:focus-visible': {
          boxShadow: theme.shadows[1],
        },
      },
      text: {
        padding: theme.spacing(2, 4),
        border: '1px solid transparent',

        '&.Mui-disabled': {
          color: theme.palette.neutral.lighter,
        },
      },
      textPrimary: {
        '&:hover': {
          backgroundColor: 'transparent',
          borderColor: theme.palette.primary.main,
        },

        '&:active, &:focus-visible': {
          color: theme.palette.primary.dark,
        },
      },
      sizeSmall: {
        padding: theme.spacing(1, 2),
        ...theme.typography.inputText,
      },
      sizeSmaller: {
        padding: theme.spacing(0.75, 1),
        fontSize: 12,
        fontFamily: 'ActoMedium',
      },
      iconSizeMedium: {
        '& svg': {
          width: theme.spacing(2.5),
          height: theme.spacing(2.5),
        },
      },
      iconSizeSmall: {
        '& svg': {
          width: theme.spacing(2.5),
          height: theme.spacing(2.5),
        },
      },
      iconSizeSmaller: {
        '& svg': {
          width: theme.spacing(1.5),
          height: theme.spacing(1.5),
        },
      },
    },
  },
  MuiButtonGroup: {
    defaultProps: {
      variant: 'contained',
      color: 'primary',
      size: 'small',
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        marginBottom: theme.spacing(2),
        boxShadow: 'none',
        '& .MuiButtonGroup-grouped:not(:first-of-type)': {
          padding: theme.spacing(1),
        },
      },
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        padding: theme.spacing(0.5),
        '& svg': {
          width: theme.spacing(3),
          height: theme.spacing(3),
        },
        '&.primary': {
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.dark,
        },
        '&.yellow': {
          backgroundColor: alpha(theme.palette.yellow.medium, 0.5),
          color: '#F1DD01',
          '& .stroke': {
            stroke: theme.palette.warning.darkest,
          },
          '& .fill': {
            fill: theme.palette.warning.darkest,
          },
        },
        '&.Mui-disabled': {
          color: theme.palette.neutral.ligher,
        },
      },
      sizeSmall: {
        width: theme.spacing(3),
        height: theme.spacing(3),

        '& svg': {
          width: theme.spacing(20 / 8),
          height: theme.spacing(20 / 8),
        },
      },
    },
  },
}

export default button
